
import { overflowContainerMixin } from '../../mixins'
import EoImg from '../EoImg/EoImg'

export default {
  name: 'EoPicture',
  components: { EoImg },
  mixins: [ overflowContainerMixin ],
  props: {
    /**
     * Image source
     */
    src: {
      type: String,
      default: null,
    },
    /**
     * Caption
     */
    caption: {
      type: String,
      default: null,
    },
    /**
     * Invisible description for screen readers
     */
    alt: {
      type: String,
      default: null,
    },
    /**
     * See <eo-img> prop 'size'
     */
    imageSize: {
      type: [String, Number],
      default: '1600x900',
    },
    /**
     * See <eo-img> prop 'width'
     */
    imageWidth: {
      type: [String, Number],
      default: null,
    },
    /**
     * Loading attribute of image: (eager) (lazy)
     */
    loading: {
      type: String,
      validator: prop => ['eager', 'lazy', '', null].includes(prop),
      default: 'lazy',
    },
    /**
     * See <eo-img> prop 'frame'
     */
    frame: {
      type: String,
      validator: prop => ['circle', 'rounded'].includes(prop),
      default: null,
    },
  },
  data () {
    return {
      hasCaptionEntered: false,
    }
  },
  computed: {
    cClasses () {
      return {
        'eo-picture': true,
        'is-landscape': this.cNaturalRatio < 1,
        'is-portrait': this.cNaturalRatio >= 1,
        'has-caption-entered': this.hasCaptionEntered,
      }
    },
    cStyle () {
      return {
        // inline styles for .eo-picture
        marginLeft: this.overflowOffset ? `-${this.overflowOffset}px` : 'auto',
        marginRight: this.overflowOffset ? `-${this.overflowOffset}px` : 'auto',
        '--natural-width': this.cWidth,
        '--natural-height': this.cHeight,
      }
    },
    cStyleCaption () {
      return {
        // inline styles for .eo-picture__caption
        paddingLeft: this.isPortrait ? '' : `${this.overflowOffset}px`,
        paddingRight: this.isPortrait ? '' : `${this.overflowOffset}px`,
      }
    },
    cHeight () {
      return this.$viewport.switch(this.imageSize)?.split('x')[1]
    },
    cWidth () {
      return this.$viewport.switch(this.imageSize)?.split('x')[0]
    },
    cNaturalRatio () {
      return this.cHeight / this.cWidth
    },
    cImageSize () {
      return `xs:600x${this.cNaturalRatio * 600} sm:900x${this.cNaturalRatio * 900} md:1200x${this.cNaturalRatio * 1200} lg:1260x${this.cNaturalRatio * 1260}`
    },
    cImageWidth () {
      return this.imageWidth || this.cNaturalRatio < 1 ? 'xs:100vw lg:1260px' : `calc(80vh * ${this.cWidth / this.cHeight})`
    },
  },
  methods: {
    async onCaptionEnter (amount) {
      this.hasCaptionEntered = amount > 0
    },
  },
}
